import React from "react";
import SEO from "../components/SEO";
import { LegalPage } from "../components/LegalPage";
import { openCookieSettings } from "../lib/consent";

const UPDATED = "October 2026";
const SECTIONS = [
  { h: "About this policy", p: [
    "This policy explains the cookies and similar technologies (such as your browser's local storage) used on camcpc.co.uk by Cambridge Cardiovascular Clinic Ltd. Essential cookies are needed for the site to work. Analytics and advertising cookies are only used if you agree, and you can change your mind at any time.",
    "Analytics and advertising tags never load on our booking, payment, contact, referral, account or admin pages, so nothing you enter there is seen by those providers. We do not use cookies to show you personalised adverts.",
  ] },
];

const ROWS = [
  ["Essential", "access_token", "Cambridge CPC (this site)", "Keeps you signed in to your account securely", "60 minutes"],
  ["Essential", "refresh_token", "Cambridge CPC (this site)", "Renews your sign-in without asking for your password again", "7 days"],
  ["Essential", "trusted_device", "Cambridge CPC (this site)", "Remembers a device you chose to trust for 2-step sign-in", "30 days"],
  ["Essential", "ccpc-consent (local storage)", "Cambridge CPC (this site)", "Remembers your cookie choices", "12 months"],
  ["Analytics", "ccpc_visit_source (local storage)", "Cambridge CPC (this site)", "Remembers how you first found us (e.g. Google search) so we know which channels help patients", "90 days"],
  ["Analytics", "_clck, _clsk", "Microsoft Clarity", "Counts visits and shows anonymised page interactions so we can fix problems", "1 year / 1 day"],
  ["Analytics", "CLID, MUID", "Microsoft (clarity.ms)", "Recognises the same browser across visits for Clarity", "1 year"],
  ["Analytics", "_ga, _ga_*", "Google Analytics (only if switched on)", "Counts visits and pages viewed", "2 years"],
  ["Advertising", "_gcl_au", "Google Ads", "Measures whether a visit from one of our adverts led to someone starting a booking", "90 days"],
];

const Table = () => (
  <section className="space-y-4" data-testid="cookie-table">
    <h2 className="font-serif text-2xl text-ink">Cookies we use</h2>
    <div className="overflow-x-auto">
      <table className="w-full text-sm border-collapse">
        <caption className="sr-only">Cookies and storage used on this website</caption>
        <thead><tr className="text-left text-ink border-b border-stone-300">
          {["Type", "Name", "Provider", "Purpose", "Lasts"].map((h) => <th key={h} scope="col" className="py-2 pr-4 font-medium">{h}</th>)}
        </tr></thead>
        <tbody>{ROWS.map((r) => (
          <tr key={r[1]} className="border-b border-stone-200 align-top">{r.map((c, i) => <td key={i} className="py-2 pr-4">{c}</td>)}</tr>
        ))}</tbody>
      </table>
    </div>
    <p>When you pay, you are taken to Stripe&apos;s secure checkout page, which sets its own essential cookies to prevent fraud (see stripe.com/cookies-policy). Google and Microsoft may also set cookies on their own websites; see their privacy policies.</p>
    <h2 className="font-serif text-2xl text-ink pt-4">Changing your choice</h2>
    <p>You can accept or reject optional cookies at any time. If you withdraw consent, we remove our analytics and advertising cookies from this site. You can also delete cookies in your browser settings.</p>
    <button type="button" onClick={openCookieSettings} data-testid="cookie-policy-settings-btn" className="btn-primary">Open cookie settings</button>
  </section>
);

export default function CookiePolicy() {
  return (
    <>
      <SEO title="Cookie Policy" description="The cookies used on the Cambridge Cardiovascular Prevention Clinic website, what they do and how long they last." path="/cookies" />
      <LegalPage testId="cookie-policy-page" eyebrow="Cookie policy" title="Cookies on our website." updated={UPDATED} sections={SECTIONS}>
        <Table />
      </LegalPage>
    </>
  );
}
